<template>
  <div class="table-responsive">
    <table class="table bg-white table-sm table-striped table-middle fs-sm">
      <thead>
        <tr>
          <th v-if="$root.user.isAdmin" class="th-shrink" />
          <th class="text-right">Ročný dohodnutý regulačný príkon (kW)</th>
          <th class="text-right">Objednávka tepla (kWh/rok)</th>
          <th class="text-right">Dátum zmeny</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id">
          <td v-if="$root.user.isAdmin" class="th-shrink">
            <b-dropdown variant="link" no-caret class="btn-p-0">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item @click.prevent="edit(item.id)">
                <b-icon icon="pencil-square" class="mr-1" />Upraviť
              </b-dropdown-item>
              <b-dropdown-item
                class="text-danger"
                @click.prevent="remove(item.id)"
              >
                <b-icon icon="trash" class="mr-1" />Vymazať
              </b-dropdown-item>
            </b-dropdown>
          </td>
          <td class="text-right">
            <template v-if="item.regulationPower">
              {{ item.regulationPower | formatNumber(4) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.heatOrder">
              {{ item.heatOrder | formatNumber(3) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.changeDate">
              {{ item.changeDate | formatDate }}
            </template>
            <template v-else> - </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    energetic: Object,
  },
  methods: {
    edit(id) {
      this.$parent.$parent.$refs.technicalForm.id = id
      this.$parent.$parent.add({ type: 'heat', edit: true })
    },
    remove: function (id) {
      this.$parent.$parent.remove(id)
    },
  },
}
</script>
